<template>
<el-dialog class="exchange-detail" :visible="showDialog" @close="onClose()" width="800">
  <div class="title" slot="title">
    {{step==1?'交換物品詳情':'交換資訊確認'}}
  </div>
  <div class="item-info" v-if="step == 1">
    <div class="img-container">
          <img :src="exchangeItem.img?exchangeItem.img:defaultimg">
        </div>
      <div class="category-group">
        <p class="category">{{exchangeItem.category}}</p>
        <p class="album" v-if="exchangeItem.category === '專卡'">{{exchangeItem.groupName}} {{exchangeItem.album}}</p>
      </div>
      <p class="member"><span v-for="(member) in exchangeItem.ownMember" :key="member">{{member}} </span> 換 <span v-for="(member,i) in exchangeItem.targetMember" :key="i">{{member}} </span></p>
      <p class="desc">{{exchangeItem.desc}}</p>
      <p class="note"><span v-for="(note) in exchangeItem.note" :key="note">#{{note}} </span></p>
      <el-form class="apply-form" v-if="applyStatus == 0">
        <div class="apply-title">申請交換</div>
        <el-form-item label="選擇擁有成員">
          <el-checkbox-group v-model="form.ownMember">
            <el-checkbox v-for="(member,i) in exchangeItem.targetMember" :label="member" :key="i" name="member"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="選擇欲交換成員">
          <el-checkbox-group v-model="form.targetMember" size="small">
            <el-checkbox v-for="(member,j) in exchangeItem.ownMember" :label="member" :key="j" name="member"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="交換方式">
          <el-checkbox-group v-model="form.exchangeWay">
            <el-checkbox v-for="(way,i) in exchangeItem.exchangeWay" :label="way"  :key="i"  name="way"></el-checkbox>
        </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-alert v-else
        title="您已提交申請"
        type="warning"
        :closable="false">
        
      </el-alert>
    </div>
    <div  class="check-form" v-if="step == 2">
        <p>
          <span class="form-title">交換物品</span>  
          <span class="category">{{exchangeItem.category}}</span>
          <span class="album" v-if="exchangeItem.category === '專卡'">{{exchangeItem.groupName}} {{exchangeItem.album}}</span>
        </p>
        <p><span class="form-title">擁有成員</span><span class="member" v-for="(member) in form.ownMember" :key="member">{{member}}</span></p>
        <p><span class="form-title">欲交換成員</span><span  v-for="(member) in form.targetMember" :key="member">{{member}}</span></p>
        <p><span class="form-title">可交易方式</span><span v-for="(way) in exchangeItem.exchangeWay" :key="way">{{way}}</span></p>
      <p class="form-title">填寫交換訊息</p>
      <el-input type="textarea" v-model="message.postMessage" placeholder="請填入訊息"></el-input>
      <div class="warning-text"><i class="el-icon-warning"></i>點擊送出即提交申請，若隨意取消交易可能會影響您的評價</div>
    </div>
     <div slot="footer" class="dialog-footer">
        <el-button @click="onClose()">{{applyStatus == 1?'關閉':step == 1?"取消":"上一步"}}</el-button>
        <el-button type="primary" @click="onSubmit()" v-if="applyStatus == 0">{{ step == 1?"下一步":"確認送出"}}</el-button>
    </div>
</el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { checkApplyStatus,applyExchangeItem  } from '../../../api/exchange'; 
export default {
  props: {
        showDialog: {
            type: Boolean,
            require: true
        },
        exchangeItem:{
          require:true
        }
    },
    data(){
      return {
        applyStatus: 0,
        defaultimg:require('../../../assets/card1.jpg'),
        step:1,
        form:{
          targetMember:[],
          ownMember:[],
          exchangeWay:[],
        },
        message:{
          postMessage:"",
        }
      }
    },
    computed:{
      ...mapState({
            userImg: state => state.user.userImg,
            userName: state => state.user.userName,
        }),
    },
    watch:{
      showDialog(newValue){
        if (newValue){
          this.form = {
          targetMember:[],
          ownMember:[],
          exchangeWay:[],
        }
        this.message = {
          postMessage:"",
        }
        this.checkStatus()
        }
      }
    },
    mouted(){
    },
    methods:{
      checkStatus(){
        checkApplyStatus({
          userName:this.$store.state.user.userName,
          itemId:this.exchangeItem.itemId
        }).then(res=>{
          this.applyStatus = res.applyStatus
          
        })
      },
      onClose(){
            if (this.step == 2){
                this.step = 1
                return
            }
            this.$emit('update:showDialog', false)
        },
        onSubmit(){
            this.submitItem()
        },
        submitItem(){
            if (this.step == 1){
                this.message.postMessage = `您好，我有${this.form.ownMember}想跟您換${this.form.targetMember}`
                this.step = 2
                return 
            } 
            let params = this.form
            params.itemId = this.exchangeItem.itemId
            params.exchangeItemId = this.exchangeItem.exchangeItemId
            params.applier = this.userName
            this.message.fromUser = this.userName
            this.message.toUser = this.exchangeItem.creator
            this.message.relatedItem = this.exchangeItem.itemId
            params.message = this.message
            applyExchangeItem(params).then(res => {
              console.log(res.data);
              this.$emit('success')
                if (res) {
                    }
                }).catch(err => {
                    console.log(err);
                });

            this.$emit('update:showDialog', false)
        },
    }

}
</script>

<style lang="scss" scoped>
.exchange-detail {
  .title{
    border-bottom: 2px solid $mainColor;
    padding-bottom: 10px;
    font-size: 20px;
  }
  .item-info {
    .img-container{
      width: 100%;
      height: 200px;
      overflow: hidden;
      position: relative;
      border-radius: 10px;
    }
    img {
      width: 100%;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .category-group {
      margin:10px 0;
      color: #fff;
      .category,.album {
        background-color: $mainColor;
        display: inline-block;
        padding: 5px 10px;
      }
      .album {
        margin-left: 20px;
        color: $textColor;
      }
    }
    .member {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    .desc,.note {
      color: $textColor;
    }
    .note {
      margin-top: 15px;
    }
    .apply-form {
      border: 1px solid $mainColor;
      border-radius: 5px;
      padding: 10px;
      margin-top: 20px;
      .apply-title {
        font-size: 16px;
        font-weight: 600;
      }
      .el-form-item {
        margin-bottom: 0px;
      }
    }
  }
  .check-form {
    font-size: 14px;
      p {
        margin-bottom: 10px;
      }
      .form-title {
        display: inline-block;
        background-color: $mainColor;
        width: 90px;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        margin-right: 10px;
      }
    .warning-text {
      margin-top: 10px;
    }
  }
}

</style>